import styles from "./style.module.scss";
import Parking from "src/assets/facilities/icon_parking.png";
import Refrigerator from "src/assets/facilities/icon_refrigerator.png";
import Washing from "src/assets/facilities/icon_washing.png";
import Bath from "src/assets/facilities/icon_bath.png";
import Cooking from "src/assets/facilities/icon_cooking.png";
import Faucet from "src/assets/facilities/icon_faucet.png";
import Kitchen from "src/assets/facilities/icon_kitchen.png";
import Towel from "src/assets/facilities/icon_towel.png";
import Wifi from "src/assets/facilities/icon_wifi.png";

const ICONS = [
  { src: Parking, name: "駐車場" },
  { src: Refrigerator, name: "冷蔵庫" },
  { src: Washing, name: "洗濯機" },
  { src: Bath, name: "お風呂 (湯船)" },
  { src: Cooking, name: "調理器具、調味料" },
  { src: Faucet, name: "屋外蛇口、玄関蛇口" },
  { src: Kitchen, name: "屋外キッチン" },
  { src: Towel, name: "タオルセット" },
  { src: Wifi, name: "Free Wi-Fi" },
];

export const FacilitySection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Facility<span>-設備・備品-</span>
        </h2>
        <div className={styles.grid}>
          {ICONS.map((item, index) => (
            <div className={styles.item} key={index}>
              <img src={item.src} alt={item.name} />
              <p>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
